// src/useTheme.js
// Custom hook for managing dark mode theme
import { useEffect } from 'react';

export const useTheme = (theme, setTheme) => {
  // Apply theme to document
  useEffect(() => {
    const html = document.documentElement;
    let actualTheme = theme;

    // If system, detect based on prefers-color-scheme
    if (theme === 'system') {
      actualTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }

    // Apply the theme class
    if (actualTheme === 'dark') {
      html.classList.add('dark');
    } else {
      html.classList.remove('dark');
    }

    // Save preference to localStorage for persistence
    localStorage.setItem('kegops-theme', theme);
  }, [theme]);

  // Listen for system theme changes when set to 'system'
  useEffect(() => {
    if (theme !== 'system') return;

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = (e) => {
      const html = document.documentElement;
      if (e.matches) {
        html.classList.add('dark');
      } else {
        html.classList.remove('dark');
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [theme]);

  // Load saved theme preference on mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('kegops-theme');
    if (savedTheme && ['light', 'dark', 'system'].includes(savedTheme)) {
      setTheme(savedTheme);
    }
  }, [setTheme]);
};

